import { useCallback, useEffect, useState } from 'react'
import { getEventProspects } from '../services/api'
import type { Prospect } from '../types/crm'

export function useProspects(eventId?: string) {
  const [prospects, setProspects] = useState<Prospect[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(async () => {
    if (!eventId) return
    setLoading(true)
    setError(null)
    try { setProspects(await getEventProspects(eventId)) }
    catch { setError('Impossible de charger les prospects.') }
    finally { setLoading(false) }
  }, [eventId])

  useEffect(() => { void reload() }, [reload])

  const updateLocal = (id: string, patch: Partial<Prospect>) =>
    setProspects((current) => current.map((item) => item.id === id ? { ...item, ...patch } : item))

  return { prospects, loading, error, reload, updateLocal }
}
